import React from 'react'
import { CartsAppContext } from '../context/carts-app-context'
import OrderPreferredRecognition from './order-preferred-recognition'
import OrderReferrer from './order-referrer'

const description = item => {
  const { autoRenew, gift, name } = item

  let text = `You will receive ${name} level member
      benefits starting today. You can renew your membership
      online.`
  if (autoRenew) {
    text = `You will be billed annually, starting today. You may remove auto-renewal from your account at any time.`
  } else if (gift) {
    text = `The recipient of this gift membership will receive ${name} level member benefits.
    They can renew their membership online.`
  }

  return text
}

const title = ({ autoRenew, name, price }) => {
  let text = `${name} Membership ($${price})`
  if (autoRenew) {
    text = `Annual ${text}`
  }
  return text
}

const onClickRemoveTicketType =
  (deleteCartItem, { id }) =>
  _ => {
    deleteCartItem(id)
  }

function MembershipItem({ item, cannotRemove }) {
  return (
    <div>
      <CartsAppContext.Consumer>
        {({ cart, actions: { deleteCartItem } }) => (
          <div className="bordered-content">
            <h2>{title(item)}</h2>

            {item.gift && (
              <p>
                <strong>This is a gift membership</strong>
              </p>
            )}

            <p className="text-16">{description(item)}</p>

            {item.showPreferredRecognitionName && !item.gift && (
              <OrderPreferredRecognition itemId={item.id} />
            )}

            <button
              className="text-link"
              type="button"
              onClick={onClickRemoveTicketType(deleteCartItem, item)}
              disabled={cannotRemove}
              data-testid="membership-remove"
            >
              Remove
            </button>
            {item.showReferredBy && (
              <OrderReferrer
                itemId={item.id}
                referredByLabel={item.referredByLabel}
                referredByHint={item.referredByHint}
              />
            )}
          </div>
        )}
      </CartsAppContext.Consumer>
    </div>
  )
}

export default MembershipItem
